<template>
  <asc-dialog :show-dialog="showDialog" :text="text" :width="400">
    <template v-if="loading">
      <asc-spinner loading></asc-spinner>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinner from '@/components/atoms/AscSpinner'
import { AscDialogMixin } from '@/components/mixins'

export default {
  name: 'AscLoadingIndicatorDialog',

  components: {
    AscDialog,
    AscSpinner,
  },

  mixins: [AscDialogMixin],

  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
